import { Button } from './styles';

type Props = {
	text: React.ReactNode;
	size?: 'small' | 'medium' | 'large';
	weight?: number;
	transparent?: boolean;
	brandColor?: boolean;
	underline?: boolean;
	disabled?: boolean;
	onClick: () => void;
};

export const ButtonInline = ({
	text,
	size = 'medium',
	weight,
	transparent,
	brandColor,
	underline,
	disabled,
	onClick,
}: Props) => (
	<Button
		type="button"
		size={size}
		weight={weight}
		transparent={transparent}
		brandColor={brandColor}
		underline={underline}
		disabled={disabled}
		onClick={onClick}
	>
		{text}
	</Button>
);
